import graph from "@irati/utils/services/graph"

import {question} from "./question"


const service = {}

export const interest = `
    id
    etag
    contentId
    questionGroups
    questions: questionsV2 @include(if: $withQuestions_Interest) {
      count
      total
      results {
        ${question}
      }
    }
`

service.list = () => {
  const query = `
    query Interests($withQuestions_Interest: Boolean = false,  $withQuestionDriver: Boolean = false) {
      interests {
        count
        total
        results {
          ${interest}
        }
      }
    }
  `
  return graph({query}).then((data) => data.interests)
}

export const getInterests = service.list

service.get = (variables, options = {}) => {
  const query = `
    query Interest ($id: String, $withQuestions_Interest: Boolean = false,  $withQuestionDriver: Boolean = false) {
      interest (id: $id) {
       ${interest}
      }
    }
  `
  return graph({query, variables}, options).then((data) => data.interest)
}

export const getInterest = service.get

export default service
